// Поля для конструктора поиска по индексам

export const TZ_FIELD_LABELS = {
  realName: 'Название',
  '190_country': 'Страна',
  '111_numReg': 'Номер регистрации',
  StatusText: 'Статус',
  Category: 'Категория',
  '210_numZayvki': 'Номер заявки',
  '181_dataIstIsklPrava': 'Дата истечения исключительного права',
  Prioritet: 'Приоритет',
  '220_dataPodachyZayav': 'Дата подачи заявки',
  '151_dataGosRegistr': 'Дата гос. регистрации',
  '450_dataPublic': 'Дата публикации',
  '732_provoobladatel': 'Правообладатель',
  '750_AdressDlyaPerepiski': 'Адрес для переписки',
  '511_KlassyMKTU': 'Классы МКТУ',
  '580_DataVnesenyaVGosReestr': 'Дата внесения в госреестр',
  '186_dataDoKotoroyProdlenSrokIsklPrava': 'Дата продления исключительного права',
  '526_neohranElem': 'Неохраняемые элементы',
  '591_ukazanieCveta': 'Указание цвета',
  '141_dataPrekrTrudOhr': 'Дата прекращения правовой охраны',
  '793_usloviaDogovora': 'Условия договора',
  '551_kollektivnyyЗнак': 'Коллективный знак',
  '554_obemnyyЗнак': 'Объёмный знак',
  '555_gолографicheskiyЗнак': 'Голографический знак',
  '556_zvukовoyЗнак': 'Звуковой знак',
  '557_obonyatelnyyЗнак': 'Обонятельный знак',
  '641_yuridicheskiSvyazannyeZayavki': 'Связанные заявки',
  '646_yuridicheskiSvyazannyeRegistracii': 'Связанные регистрации',
  '550_vidznaka': 'Вид знака',
  url_numReg: 'Ссылка на документ',
  url_210_numZayvki: 'Ссылка на заявку',
  url_450_dataPublic: 'Ссылка на публикацию',
  img_url: 'Ссылка на изображение',
  // ИИ
  elements: 'Элементы (ИИ)',
  colors: 'Цвета (ИИ)',
  text_content: 'Текстовое содержание (ИИ)',
  semantic_description: 'Семантическое описание (ИИ)',
};

export const REQUEST_FIELD_LABELS = {
  realName: 'Название',
  '210_Номер_заявки': 'Номер заявки',
  '200_Дата_поступления_заявки': 'Дата поступления',
  '220_Дата_подачи_заявки': 'Дата подачи',
  '441_Опубликовано': 'Опубликовано',
  '190_Страна': 'Страна',
  '511_КлассыМКТУ': 'Классы МКТУ',
  '511_Классы_МКТУ_и_перечень_товаров_и/или_услуг': 'Классы МКТУ и товары/услуги',
  'Состояние_делопроизводства': 'Состояние делопроизводства',
  Статус: 'Статус',
  '731_Заявитель': 'Заявитель',
  '740_Патентный_поверенный_(полное_имя,_регистрационный_номер,_местонахождение)': 'Патентный поверенный',
  '750_Адрес_для_переписки': 'Адрес для переписки',
  img_url: 'Ссылка на изображение',
  '540_Изображение_(воспроизведение)_заявляемого_обозначения': 'Текстовое описание изображения',
  url_210_Номер_заявки: 'Ссылка на заявку',
  url_441_Опубликовано: 'Ссылка на публикацию',
  'url_540_Изображение_(воспроизведение)_заявляемого_обозначения': 'Ссылка на изображение',
  // ИИ
  elements: 'Элементы (ИИ)',
  colors: 'Цвета (ИИ)',
  text_content: 'Текстовое содержание (ИИ)',
  semantic_description: 'Семантическое описание (ИИ)',
};

export const WIPO_FIELD_LABELS = {
  Trademark: 'Имя товарного знака',
  Image: 'Изображение',
  Status: 'Статус',
  Origin: 'Страна происхождения',
  Designations: 'Обозначения',
  Holder: 'Правообладатель',
  'Holder Address': 'Адрес правообладателя',
  'Holder country': 'Страна правообладателя',
  Representative: 'Представитель',
  'Rep. Address': 'Адрес представителя',
  'Rep. Country': 'Страна представителя',
  Relevance: 'Релевантность',
  'Reg. No': 'Номер регистрации',
  'Basic app. no.': 'Номер базовой заявки',
  'Basic. reg. no.': 'Номер базовой регистрации',
  'Reg. Date': 'Дата регистрации',
  'Exp. Date': 'Дата истечения',
  'Nice Cl.': 'Класс МКТУ (Nice)',
  'Vienna Cl.': 'Класс Венской классификации',
  // ИИ
  elements: 'Элементы (ИИ)',
  colors: 'Цвета (ИИ)',
  text_content: 'Текстовое содержание (ИИ)',
  semantic_description: 'Семантическое описание (ИИ)',
};

export const makeOptions = (obj) =>
  Object.entries(obj).map(([value, label]) => ({ value, label }));
